<div class="bm-back-button-container">
  <button class="bm-button desktop" (click)="goBack()">
    <svg
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0204537 12.0894C0.041782 12.3788 0.158579 12.6541 0.353566 12.8694L9.71357 23.2694C9.94412 23.5253 10.2671 23.6797 10.6114 23.6979C10.9557 23.7162 11.2939 23.5974 11.5498 23.3669C11.8068 23.1363 11.9611 22.8133 11.9794 22.4691C11.9977 22.1238 11.8779 21.7866 11.6473 21.5306L3.06732 12.0001L11.6473 2.46949C11.8779 2.21254 11.9977 1.87534 11.9794 1.53105C11.9611 1.18676 11.8068 0.863783 11.5498 0.633241C11.2939 0.402694 10.9557 0.282839 10.6114 0.301143C10.2671 0.319425 9.94411 0.473799 9.71357 0.730741L0.353566 11.1307C0.116924 11.3918 -0.00292029 11.7381 0.0204537 12.0895V12.0894Z"
        fill="black"
      />
    </svg>
    <span [translate]="'back'"></span>
  </button>
  <!-- <button class="bm-button mobile" (click)="goBack()">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00192 10.5576C5.01618 10.7431 5.09429 10.9195 5.22467 11.0576L11.4836 17.7241C11.6378 17.8882 11.8538 17.9871 12.084 17.9988C12.3142 18.0105 12.5404 17.9344 12.7115 17.7866C12.8833 17.6388 12.9866 17.4318 12.9988 17.2111C13.011 16.9897 12.9309 16.7736 12.7767 16.6095L7.03933 10.5003L12.7767 4.39111C12.9309 4.2264 13.011 4.01025 12.9988 3.78956C12.9865 3.56886 12.8833 3.36183 12.7115 3.21405C12.5404 3.06627 12.3142 2.98944 12.084 3.00117C11.8538 3.01289 11.6378 3.11185 11.4836 3.27655L5.22467 9.94308C5.06643 10.1104 4.98629 10.3324 5.00192 10.5577V10.5576Z"
        fill="#254C54"
      />
    </svg>
  </button> -->
</div>
